import { AnimatePresence, motion } from 'framer-motion';
import { FC } from 'react';

interface TabSwitchProps {
	selectedTab: string;
	onTabChange: (tab: string) => void;
}

const TabSwitch: FC<TabSwitchProps> = ({ selectedTab, onTabChange }) => {
	return (
		<div className="w-full rounded-full bg-[#F8F8FA] p-1.5 dark:bg-gray-900">
			<div className="relative flex w-full">
				<AnimatePresence initial={false}>
					<motion.div
						className="absolute rounded-[24px] bg-[#F0EBFC] dark:bg-gray-800"
						layout
						transition={{
							type: 'spring',
							duration: 0.5,
							bounce: 0.15,
						}}
						style={{
							width: '50%',
							height: '100%',
							top: 0,
							left: selectedTab === 'outbound' ? '50%' : '0%',
						}}
					/>
				</AnimatePresence>
				<button
					onClick={() => {
						onTabChange('inbound');
					}}
					className={`relative z-10 flex flex-1 items-center justify-center gap-1 px-4 py-1.5 text-sm font-medium transition-colors ${
						selectedTab === 'inbound' ? 'text-[#B18EED]' : 'text-gray-500'
					}`}
				>
					<svg
						width={24}
						height={24}
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19 5L15 9M15 9V6M15 9H18"
							stroke={selectedTab === 'inbound' ? '#6E5DED' : '#A29FB9'}
							strokeWidth={1.5}
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							opacity={0.5}
							d="M10.0376 5.31617L10.6866 6.4791C11.2723 7.52858 11.0372 8.90532 10.1147 9.8278C10.1147 9.8278 10.1147 9.8278 10.1147 9.8278C10.1146 9.82792 8.99588 10.9468 11.0245 12.9755C13.0525 15.0035 14.1714 13.8861 14.1722 13.8853C14.1722 13.8853 14.1722 13.8853 14.1722 13.8853C15.0947 12.9628 16.4714 12.7277 17.5209 13.3134L18.6838 13.9624C20.2686 14.8468 20.4557 17.0692 19.0628 18.4622C18.2258 19.2992 17.2004 19.9505 16.0669 19.9934C14.1588 20.0658 10.9183 19.5829 7.6677 16.3323C4.41713 13.0817 3.93421 9.84122 4.00655 7.93309C4.04952 6.7996 4.7008 5.77423 5.53781 4.93723C6.93076 3.54428 9.15317 3.73144 10.0376 5.31617Z"
							fill={selectedTab === 'inbound' ? '#6E5DED' : '#A29FB9'}
						/>
					</svg>

					<span className="text-base font-bold">Inbound</span>
				</button>

				<button
					onClick={() => {
						onTabChange('outbound');
					}}
					className={`relative z-10 flex flex-1 items-center justify-center gap-1 px-4 py-1.5 text-sm font-medium transition-colors ${
						selectedTab === 'outbound' ? 'text-[#B18EED]' : 'text-gray-500'
					}`}
				>
					<svg
						width={24}
						height={24}
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15 9L19 5M19 5V8M19 5H16"
							stroke={selectedTab === 'outbound' ? '#6E5DED' : '#A29FB9'}
							strokeWidth={1.5}
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
						<path
							opacity={0.5}
							d="M10.0376 5.31617L10.6866 6.4791C11.2723 7.52858 11.0372 8.90532 10.1147 9.8278C10.1147 9.8278 10.1147 9.8278 10.1147 9.8278C10.1146 9.82792 8.99588 10.9468 11.0245 12.9755C13.0525 15.0035 14.1714 13.8861 14.1722 13.8853C14.1722 13.8853 14.1722 13.8853 14.1722 13.8853C15.0947 12.9628 16.4714 12.7277 17.5209 13.3134L18.6838 13.9624C20.2686 14.8468 20.4557 17.0692 19.0628 18.4622C18.2258 19.2992 17.2004 19.9505 16.0669 19.9934C14.1588 20.0658 10.9183 19.5829 7.6677 16.3323C4.41713 13.0817 3.93421 9.84122 4.00655 7.93309C4.04952 6.7996 4.7008 5.77423 5.53781 4.93723C6.93076 3.54428 9.15317 3.73144 10.0376 5.31617Z"
							fill={selectedTab === 'outbound' ? '#6E5DED' : '#A29FB9'}
						/>
					</svg>

					<span className="text-base font-bold">Outbound</span>
				</button>
			</div>
		</div>
	);
};

export default TabSwitch;
